export default "__VITE_ASSET__2b6253a6__"